import './floatingmenus.css';

const FloatingMenus = ({
  activeKey, // optional: "vehicles" | "alerts" | "fleettable" | "history" | "fleetmanager" | "account" | "help"
  onVehicleIconClick,
  onAlertIconClick,
  onAccountIconClick,
  onFleetTableIconClick,
  onHistoryIconClick,
  onFleetManagerIconClick,
  onHelpIconClick,

  // optional badges (numbers)
  badges = { vehicles: 3, alerts: 1 }, // e.g. { vehicles: 3, alerts: 1 }
}) => {
  const items = [
    { key: 'vehicles', label: 'Vehicles', icon: 'bi bi-truck', onClick: onVehicleIconClick },
    // { key: 'alerts', label: 'Alerts', icon: 'bi bi-bell', onClick: onAlertIconClick },
    { key: 'fleettable', label: 'Logs', icon: 'bi bi-table', onClick: onFleetTableIconClick },
    { key: 'history', label: 'History', icon: 'bi bi-clock', onClick: onHistoryIconClick },
    { key: 'fleetmanager', label: 'Fleet', icon: 'bi bi-person-gear', onClick: onFleetManagerIconClick },
    { key: 'account', label: 'Account', icon: 'bi bi-person', onClick: onAccountIconClick },
    { key: 'help', label: 'Help', icon: 'bi bi-patch-question', onClick: onHelpIconClick },
  ];

  return (
    <nav className="floatingmenu-dock" aria-label="Quick actions">
      <div className="floatingmenu-dock-inner floatingmenu-noscrollbar">
        {items.map((it) => {
          const isActive = activeKey === it.key;
          const badgeValue = badges?.[it.key];

          return (
            <div key={it.key} className='floatingmenu-div-btn'>
              <button
                type="button"
                className={`floatingmenu-btn ${isActive ? 'is-active' : ''}`}
                onClick={it.onClick}
                aria-label={it.label}
                aria-current={isActive ? 'page' : undefined}
              >
                {Number.isFinite(badgeValue) && badgeValue > 0 && (
                  <span className="floatingmenu-badge" aria-label={`${badgeValue} notifications`}>
                    {badgeValue > 99 ? '99+' : badgeValue}
                  </span>
                )}

                <i className={`floatingmenu-icon ${it.icon}`} />

                {/* Desktop tooltip label (appears on hover/focus) */}
                <span className="floatingmenu-tooltip" role="tooltip">
                  {it.label}
                </span>
              </button>
              {/* Mobile label (always visible on small screens) */}
              <span className="floatingmenu-label">{it.label}</span>
            </div>
          );
        })}
      </div>
    </nav>
  );
};

export default FloatingMenus;
